<template>
  <div class="popup" :class="{ minimized: minimized }">
    <FactuurExampleForm v-if="showFactuurExampleForm" :factuur="showFactuurExampleForm" @close="showFactuurExampleForm = false" />

    <ArchiveerForm v-if="showArchiveerForm" @submit="archiveerOpdracht($event)" @close="showArchiveerForm = false" />
    <Topbar :minimized="minimized" :opdracht="opdracht" @archiveer="showArchiveerForm = true" @duplicate="dupliceerOpdracht()" />
    <div class="body">
      <div :class="{ fullWidth: !showProgress }" class="left">
        <div class="row">
          <Aanvraag class="block aanvraag" :selectedOpdracht="opdracht" />
          <Koppeling class="block koppeling" :opdracht="opdracht" />
        </div>

        <div class="row">
          <div class="blok">
            <div class="content">
              <div class="header">
                <div class="titel">Intake</div>
                <span v-if="opdracht.afhandeling?.intakeAdmin?.timestamp">Ingevuld: {{ opdracht.afhandeling?.intakeAdmin?.timestamp?.toDate().toLocaleDateString() }}</span>
              </div>
              <textarea v-model="intake" class="intake-textarea" placeholder="Vul hier je intake in met de opdrachtgever..." />
              <button class="cta" v-if="isSaveIntakeButtonVisible" @click="saveIntake()">Sla intake op</button>
            </div>
          </div>
          <div class="blok">
            <div class="content">
              <div class="header">
                <div class="titel">Admin Logs</div>
              </div>
              <div class="header">
                <input v-model="newLog" class="newLogInput" style="flex-grow: 1;" placeholder="Voeg een nieuwe log toe..." />
                <button class="cta" @click="isSaveLogButtonVisible && saveNewLog()" style="width: 40px;">+</button>
              </div>
              <div class="logs" v-for="(x, i) in [...(opdracht.afhandeling?.logsAdmin || [])]?.reverse()" :key="i">
                {{ x.content }}
              </div>
            </div>

            <div>
              <div class="tags" v-if="startContent">
                <div class="tag">start:<br />{{ startContent?.startDatum?.toDate()?.toLocaleDateString() }}</div>
                <div class="tag">verwacht einddatum:<br />{{ startContent?.verwachtEindDatum?.toDate()?.toLocaleDateString() }}</div>
              </div>
              <div class="tags" v-if="startContent">
                <div class="tag">prijsafspraak:<br />{{ startContent?.prijsAfspraak }}</div>
                <div class="tag">prijs:<br />{{ startContent?.prijs }}</div>
              </div>
            </div>
          </div>
          <div class="blok">
            <div class="content">
              <div class="header">
                <div class="titel">Feedback Tekenaar</div>
              </div>
              <div class="feedback" v-for="(feedback, i) in opdracht.feedbackTekenaar" :key="i">
                <div class="text">
                  <p>
                    {{ feedback.content }}
                  </p>
                </div>

                <span>
                  {{ feedback.timestamp?.toDate().toLocaleDateString() }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="opdracht.facturen.length" class="row">
          <Facturen @showFactuur="showFactuurExampleForm = $event" class="block facturen" :facturen="opdracht.facturen" />
        </div>
      </div>

      <div :class="{ hidden: !showProgress }" class="progress">
        <h4 style="padding-bottom: 15px; text-align:center;">Status: {{ progressText }}</h4>
        <div v-if="!gearchiveerd && opdracht.statusString === 'Nieuw'" class="gearchiveerdNotice positive">
          <p>Deze opdracht is nieuw</p>
          <button @click="zetInBehandeling()" v-if="!opdracht.gearchiveerd?.approved">Zet in behandeling</button>
        </div>
        <div v-if="!gearchiveerd && opdracht.statusString === 'Uitgezet' && opdracht.tekenaar" class="gearchiveerdNotice positive">
          <p>De tekenaar is uitgenodigd...</p>
          <!-- <button @click="zetInBehandeling()" v-if="!opdracht.gearchiveerd.approved">Zet in behandeling</button> -->
        </div>
        <div v-if="gearchiveerd" class="gearchiveerdNotice">
          <p v-if="gearchiveerd.event === 0">Deze opdracht is gearchiveerd door de tekenaar</p>
          <p v-else>Deze opdracht is gearchiveerd</p>
          <button @click="approveArchivering()" v-if="gearchiveerd.event === 0">Bevestig archivering</button>
          <button v-if="gearchiveerd.event !== 2" @click="resetArchivering()">Reset opdracht</button>
          <p v-if="gearchiveerd.event === 2"><br />archiveringen door een partner kunnen niet ongedaan gemaakt worden</p>
          <button v-if="gearchiveerd.event === 1" @click="undoArchivering()">Maak archivering ongedaan</button>
        </div>
        <VoortgangsBalk :opdracht="opdracht" :dark="true" />
        <div v-if="opdracht.status && opdracht.status.length" class="progressLogWrapper">
          <div v-for="(x, i) in opdracht.status.slice().reverse()" :key="i" class="update" :class="{ orangeTint: x.event < 10 }">
            <span>{{ progressLogText(x.event) }}</span>
            <span v-if="x.note">{{ x.note }}</span>
            <span>{{ x.timestamp.toDate().toLocaleDateString() }}</span>

            <div v-if="JSON.stringify(x.content) && x.event > 9">
              <div v-for="(ting, key, i) in x.content" :key="i">
                <div class="contentextra" v-if="ting && !ting.seconds">
                  <div class="title">{{ key }}</div>
                  <div class="text">{{ ting }}</div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="contentextra">
                <div class="title">{{ x.content }}</div>
                <div v-if="x.content" class="text">Bericht</div>
              </div>
            </div>

            <p v-if="x.userId"><img :src="selectedTekenaarVoornaam(x.userId).image" alt="" />{{ selectedTekenaarVoornaam(x.userId).name }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db, fieldValue } from "@/firebase"

import ArchiveerForm from "./components/ArchiveerForm.vue"
import FactuurExampleForm from "./components/FactuurExampleForm"

import VoortgangsBalk from "@/components/v2/voortgangsBalk"

import Topbar from "./components/Topbar"
import Aanvraag from "./components/aanvraag"
import Koppeling from "./components/koppeling"
import Facturen from "./components/Facturen"
import { ref } from "@vue/reactivity"
import { useStore } from "vuex"
import { computed, watchEffect } from "@vue/runtime-core"

export default {
  setup() {
    const store = useStore()

    const storedIntake = computed(() => store.getters["opdracht/opdrachtData"]?.afhandeling?.intakeAdmin?.content || "")

    const intake = ref(storedIntake.value || "")

    const opdrachtId = computed(() => store.getters["opdracht/opdrachtData"]?.id || "")

    watchEffect(() => {
      console.log(opdrachtId.value)
      intake.value = storedIntake.value || ""
    })

    const isSaveIntakeButtonVisible = computed(() => intake.value && storedIntake.value !== intake.value)
    const isSaveLogButtonVisible = computed(() => newLog.value)

    const saveIntake = () => {
      if (!intake.value || !opdrachtId.value) return alert("Vul eerst een intake in. Werkt het daarna nog steeds niet? Dan is deze opdracht niet goed ingeladen. Herlaad de pagina.")

      const opdrachtRef = db.doc(`opdrachten/${opdrachtId.value}`)

      opdrachtRef.update({
        "afhandeling.intakeAdmin": {
          content: intake.value,
          timestamp: new Date()
        }
      })
    }

    const newLog = ref("")

    const saveNewLog = () => {
      if (!newLog.value || !opdrachtId.value) return alert("Vul eerst een nieuwe log in. Werkt het daarna nog steeds niet? Dan is deze opdracht niet goed ingeladen. Herlaad de pagina.")

      const opdrachtRef = db.doc(`opdrachten/${opdrachtId.value}`)

      opdrachtRef.update({
        "afhandeling.logsAdmin": fieldValue.arrayUnion({
          content: newLog.value,
          timestamp: new Date()
        })
      })

      newLog.value = ""
    }

    return {
      intake,
      isSaveIntakeButtonVisible,
      newLog,
      isSaveLogButtonVisible,
      saveIntake,
      saveNewLog
    }
  },

  data() {
    return {
      showFactuurExampleForm: false,

      showArchiveerForm: false,
      showProgress: true
    }
  },
  components: {
    ArchiveerForm,
    FactuurExampleForm,
    VoortgangsBalk,
    //
    Topbar,
    Aanvraag,
    Koppeling,
    Facturen
  },
  created() {
    window.addEventListener("keydown", this.minimizeListener)
  },
  unmounted() {
    window.removeEventListener("keydown", this.minimizeListener)
  },

  computed: {
    gearchiveerd() {
      if (this.opdracht.status && this.opdracht.status[this.opdracht.status?.length - 1].event < 10) {
        return this.opdracht.status[this.opdracht.status?.length - 1]
      }
      return false
    },
    minimized() {
      return this.$store.state.opdracht.minimized
    },
    opdracht() {
      return this.$store.getters["opdracht/opdrachtData"]
    },
    progressText() {
      const status = this.opdracht.statusString
      if (this.opdracht.geannuleerd || this.opdracht.onhold || this.gearchiveerd) return "Gearchiveerd"
      if (status === "Nieuw") return "Nieuw"
      if (status === "In behandeling") return "In Behandeling"
      if (status === "Uitgezet") return "Uitgezet"
      if (status === "Geaccepteerd") return "Geaccepteerd"
      if (status === "Intake") return "Intake Tekenaar"
      if (status === "Gestart") return "Lopend"
      if (status === "Beëindigd") return "Lopend + Facturen"
      return 0
    },
    tekenaars() {
      return this.$store.state.userAccounts
    }
  },
  methods: {
    async dupliceerOpdracht() {
      if (confirm("Weet je zeker dat je deze opdracht wilt dupliceren? Dit betekent dat er een nieuwe opdracht wordt aangemaakt vanaf dezelfde startdata. De voortgang en/of gekoppelde tekenaars worden hierin niet meegenomen.")) {
        const latestOpdrachtNummer = await db.doc("aggregation/opdrachten").get()

        await db.collection("opdrachten").add({
          ...this.opdracht,
          metadata: {
            ...this.opdracht.metadata,
            opdrachtNummer: latestOpdrachtNummer.data().opdrachtNummerCounter + 1,
            duplicateOf: this.opdracht.id,
            createdAt: new Date()
          },
          opdrachtgever: {
            ...this.opdracht.opdrachtgever,
            email: ""
          },
          id: "",
          afhandeling: {
            tekenaar: ""
          },
          status: [
            {
              event: 10,
              timestamp: new Date()
            }
          ]
        })

        await db.doc("aggregation/opdrachten").update({
          opdrachtNummerCounter: fieldValue.increment(1)
        })

        alert("Opdracht succesvol gedupliceerd!")
        alert("Let op: de gedupliceerde opdracht heeft geen email adres.")
      }
    },

    async resetArchivering() {
      // todo: arrayUnion in de progress voor een archivering die wordt gereset, met een tussenstap. Oftewel 2 logs. 1 met event: 1 (of 2?) dat wordt de code voor een 'terugzet' handeling., daarna een arrayUnion naar 10, zodat hij opnieuw gestart kan worden.

      await db.doc(`opdrachten/${this.opdracht.id}`).update({
        "afhandeling.tekenaar": "",

        status: fieldValue.arrayUnion({
          timestamp: new Date(),
          adminId: this.$store.state.adminId,
          event: 9
        })
      })
      await db.doc(`opdrachten/${this.opdracht.id}`).update({
        status: fieldValue.arrayUnion({
          timestamp: new Date(),
          event: 10,
          adminId: this.$store.state.adminId
        })
      })
    },

    selectedTekenaarVoornaam(id) {
      if (!id) return null
      return {
        name: this.tekenaars.find(e => e.id === id)?.userProfile?.voornaam,
        image: this.tekenaars.find(e => e.id === id)?.userProfile?.profilePictureURL
      }
    },
    progressLogText(progress) {
      if (progress === 0) return "Gearchiveerd door tekenaar"
      if (progress === 1) return "Gearchiveerd door admin"
      if (progress === 2) return "Gearchiveerd door partner"
      if (progress === 8) return "Archivering ongedaan"
      if (progress === 9) return "Opdracht gereset"
      if (progress === 10) return "Opdracht aangemaakt"
      if (progress === 20) return "In behandeling gezet"
      if (progress === 30) return "Tekenaar uitgenodigd"
      if (progress === 40) return "Voorwaarden geaccepteerd"
      if (progress === 50) return "Intake door tekenaar"
      if (progress === 60) return "Opdracht is gestart"
      if (progress === 70) return "Lopend + Facturen"
      return 0
    },
    archiveerOpdracht(e) {
      db.doc(`opdrachten/${this.opdracht.id}`).update({
        status: fieldValue.arrayUnion({
          event: 1,
          timestamp: new Date(),
          adminId: this.$store.state.adminId,
          content: e
        })
      })
    },

    async undoArchivering() {
      const obj = [...this.opdracht.status]
        .slice()
        .reverse()
        .filter(e => e.event > 9)[0]

      if (confirm("Wil je deze opdracht weer terugzetten naar zijn staat van vóór archivering?")) {
        await db.doc(`opdrachten/${this.opdracht.id}`).update({
          status: fieldValue.arrayUnion({
            timestamp: new Date(),
            adminId: this.$store.state.adminId,
            event: 8 // ongedaan maken?
          })
        })
        await db.doc(`opdrachten/${this.opdracht.id}`).update({
          status: fieldValue.arrayUnion({
            ...obj,
            timestamp: new Date()
          })
        })
      }
    },

    approveArchivering() {
      db.doc(`opdrachten/${this.opdracht.id}`).update({
        status: fieldValue.arrayUnion({
          event: 1,
          timestamp: new Date(),
          adminId: this.$store.state.adminId
        })
      })
    },
    zetInBehandeling() {
      db.doc(`opdrachten/${this.opdracht.id}`).update({
        status: fieldValue.arrayUnion({
          event: 20,
          timestamp: new Date(),
          adminId: this.$store.state.adminId
        })
      })
    },
    minimizeListener(e) {
      if (e.key === "d" && (e.ctrlKey || e.metaKey)) {
        e.preventDefault()
        this.$store.commit("opdracht/toggleMinimize")
      }
      if (e.key === "Escape") {
        e.preventDefault()
        this.$store.commit("opdracht/close")
      }
    }
  }
}
</script>

<style lang="sass" scoped>


.logs
  width: 100%
  padding: 0.5rem 0.7rem
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2)
  border-radius: 0.5rem
  font-size: 12px
  overflow-wrap: normal
  max-width: 100%
  margin-bottom: 0.5rem
  word-wrap: normal
  word-break: break-all

.cta
  width: 100%
  opacity: 1
  &:hover
    opacity: 0.8

  cursor: pointer
  background-color: black
  padding: 0.7rem
  font-weight: 500
  color: white
  border: none
  border-radius: 0.5rem
  font-size: 14px
  margin-bottom: 0.75rem

.intake-textarea
  width: 100%
  min-height: 200px
  margin-bottom: 1rem
  border-radius: 0.5rem
  padding: 0.75rem
  background-color: rgba(0, 0, 0, 0.05)
  border: none


.contentextra
  display: flex
  flex-direction: column
  font-size: 14px
  .title
    font-weight: 600
    margin-top: 10px

.row
  padding: 0 0 30px
  display: flex
  .blok
    background-color: white
    padding: 24px 24px 9px
    border-radius: 15px
    width: 100%
    display: flex
    flex-direction: column
    justify-content: space-between !important
    overflow-y: scroll
    .content
      display: flex
      flex-direction: column
      align-items: flex-start
      .header
        display: flex
        align-items: center
        justify-content: space-between
        padding: 0 0 15px
        width: 100%
        *
          white-space: nowrap
        span
          opacity: .4
          font-size: 12px
          display: block
        input
          height: 100%
          border-radius: 8px 0 0 8px
          padding: 0.5rem
        button
          border-radius: 0 8px 8px 0
          margin: 0

      .titel
        font-weight: 600
      .value
        padding: 0 0 25px
        font-size: 15px
        color: rgba(0, 0, 0, 0.7)
      .feedback
        width: 100%
        border-bottom: 1px solid rgba(0, 0, 0, 0.2)
        font-size: 13px
        padding: 6px 0
        span
          opacity: .5
          font-size: 11px
    .tags
      padding: 0 0 15px
      display: flex
      align-items: center
      .tag
        width: 50%
        font-size: 11px
        padding: 4px 8px
        border-radius: 1000px
        color: rgba(0, 0, 0, 0.7)





@media only screen and (max-width: 1150px)
  .row
    flex-direction: column !important
    .koppeling
      max-width: none !important
.popup
  position: fixed
  z-index: 99
  inset: 5vh 0 0
  max-width: 1400px
  margin: 0 auto
  background-color: #f4f4f4
  border-radius: 14px 14px 0 0
  transition: .4s
  // box-shadow: 0 0 400px rgba(0, 0, 0, 0.4)
  overflow: hidden
  &.minimized
    transform: translateY(calc( 100% - 57px ))

  .block
    background-color: white
    border-radius: 14px
    width: 100%
    &.koppeling
      max-width: 250px

  .body
    display: flex
    width: 100%
    height: 100%
    padding: 0 0 30px

    .left
      overflow-y: scroll
      flex-grow: 1
      padding: 30px
      max-width: calc( 100% - 320px )
      &.fullWidth
        max-width: calc( 100% - 40px )

      .row
        gap: 30px
        display: flex
        justify-content: space-between




    .progress
      position: absolute
      inset: 0 0 0 auto
      border-left: 1px solid rgba(0, 0, 0, 0.1)
      background-color: white
      width: 320px
      padding: 20px 20px
      overflow-y: scroll
      background-color: black
      color: white
      &.hidden
        transform: translateX(calc( 100% - 40px )) !important


      .gearchiveerdNotice
        background-color: red
        color: white
        margin-bottom: 15px
        border-radius: 5px
        padding: 10px
        font-size: 15px
        p
          text-align: center
          font-weight: 500
          font-size: 14px
        button
          background-color: black
          color: white
          border: none
          outline: none
          padding: 8px 10px
          border-radius: 4px
          cursor: pointer
          width: 100%
          margin-top: 10px
          font-weight: 600
          &:hover
            opacity: .8
        &.positive
          background-color: hsl(210, 95%, 50%)

      .progressLogWrapper
        .update
          padding: 15px
          margin-top: 20px
          border: 1px solid rgba(0, 0, 0, 0.06)
          border-radius: 8px
          display: flex
          flex-direction: column
          background-color: #041830
          &.orangeTint
            background-color: #fea5014a
          // box-shadow: 0 15px 30px rgba(0, 0, 0, 0.05)
          p
            font-size: 13px
            display: flex
            align-items: center
            background-color: rgba(0, 0, 0, 0.06)
            border-radius: 1000px
            width: fit-content
            padding: 4px 10px 4px 4px
            margin-top: 10px

            img
              margin-right: 4px
              width: 20px
              height: 20px
              object-fit: cover
              border-radius: 100%
          span
            font-size: 11px
            opacity: 0.4
            &:first-of-type
              opacity: 1
              font-size: 15px
              font-weight: 600
              padding-bottom: 8px
</style>
